module.exports = __webpack_public_path__ + "media/images/responsive/costumes/icon_search-4f05e86444b23d448c89f373bdb9ea4c.svg";